import { adjustmentService } from '@/services';
import BaromoneyReportVM from '@/view-model/baromoney-report/BaromoneyReportVM';
import { BusinessError } from '@/error';
export default {
    setBetweenDate({ commit }, payload) {
        commit('SET_BETWEEN_DATE', payload);
    },
    /**
     * 허브 바로머니 리포트 기본 내역 호출
     */
    async getBasicBaromoneyReport({ getters, commit, }, { hubId, }) {
        const [fromAt, toAt,] = getters.getterBetweenDateToTimeStamp;
        try {
            const param = {
                fromAt,
                toAt,
            };
            const [data,] = await Promise.all([
                adjustmentService.getBasicBaromoneyReport(hubId, param),
            ]);
            const { transactions, balanceAmount, } = data.data;
            const report = new BaromoneyReportVM({
                transactions,
                balanceAmount,
            });
            const tableItems = report.setTableItems();
            commit('GET_BASIC_BAROMONEY_REPORT', tableItems);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            // statusCode 200인 경우
            if (error instanceof BusinessError) {
                return {
                    isSuccess: false,
                    message: error.message,
                    errorCode: error.code,
                };
            }
            console.log('[getBasicBaromoneyReport] ', error.message);
            return {
                isSuccess: false,
            };
        }
    },
};
